import { Injectable } from '@angular/core';
import { Game } from 'core/models/game';
import { Widget } from 'app/widget/widget';
import { MarsTutorizationComponent } from './mars-tutorization/mars-tutorization.component';
import { Group } from 'core/models/group';

const TUTORIZABLES = ['mars'];

@Injectable()
export class TutorizationService {
  private widgetsFactory = {
    mars: (group, game) => this.getMarsTutorizationWidgets(group, game)
  };

  constructor() {}

  hasTutorization(game: Game) {
    return TUTORIZABLES.includes(game.canonicName);
  }

  getTutorizationWidgets(group: Group, game: Game) {
    return this.widgetsFactory[game.canonicName](group, game);
  }

  getMarsTutorizationWidgets(group: Group, game: Game) {
    const id = Date.now();
    const widgets = [
      new Widget(MarsTutorizationComponent, {
        id: `widget- '${id}'`,
        name: `widget- '${id}'`,
        group: group,
        game: game
      })
    ];
    return widgets;
  }
}
